import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { createVodOutputs, removeVodOutputs } from '../store/actions/vodOutputsActions';
import { createVodOutput, removeVodOutput } from '../store/externalCalls/api/vodOutput';

export default {
  apiCreate: createVodOutput,
  actionCreate: createVodOutputs,
  apiRemove: removeVodOutput,
  actionRemove: removeVodOutputs,
  attributeName: storeStructure.VoDOutputs,
  storeNode: storeStructure.VoDOutputs,
  canOpen: false,
  canEdit: false,
  canCreate: true,
  canRemove: true,
  emptyMessage: "You don't have any outputs for this vod.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: true,
      canCreate: true,
      helpText: 'Name of the output',
      width: '12rem',
    },
    {
      attributeName: 'outputFile',
      label: 'Output File Url',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '20rem',
      default: '',
      canEdit: true,
      canCreate: true,
      helpText: 'Url of the output file',
    },
  ],
};
